module.exports = __webpack_public_path__ + "media/images/account/icon3-800110ee56e7ca2898b7b8fd908b53f5.svg";